module.exports = __webpack_public_path__ + "img/chengzhangfenxi.afe2b69c.svg";